// open menu on hover
// let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
// items.forEach(item => {
//  item.addEventListener("mouseover", () => {
//   item.setAttribute("open", true);
//    item.querySelector("ul").addEventListener("mouseleave", () => {
//      item.removeAttribute("open");
//    });
//    item.addEventListener("mouseleave", () => {
//      item.removeAttribute("open");
//    });
//  });
// });

document.addEventListener('DOMContentLoaded', function () {
  var menuParents = document.querySelectorAll('.mega-menu');

  menuParents.forEach(function (details) {
    var summary = details.querySelector('summary');
    var content = details.querySelector('.mega-menu__content');
    if (!summary || !content) return;

    var closeTimer;

    function openMenu() {
      clearTimeout(closeTimer);
      menuParents.forEach(function (other) {
        if (other !== details) {
          other.removeAttribute('open');
          other.classList.remove('is-open');
        }
      });
      details.setAttribute('open', '');
      details.classList.add('is-open');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        details.classList.remove('is-open');
        details.removeAttribute('open');
      }, 100);
    }

    // summary AND content banne par listener - je element par mouse hoy e matter nathi
    [summary, content].forEach(function (el) {
      el.addEventListener('mouseenter', openMenu);
      el.addEventListener('mouseleave', scheduleClose);
    });

    summary.addEventListener('click', function (e) {
      e.preventDefault();
    });
  });
});

/**
 * Initializes a Swiper instance on every product-card media slider.
 * Include this file after the Swiper library script, and after this
 * snippet's HTML has been rendered on the page.
 *
 * Handles the common Dawn gotcha: the whole card is usually wrapped in an
 * <a href="{{ card_product.url }}"> link. Without stopping propagation,
 * clicking the next/prev arrows or dragging a slide would trigger card
 * navigation instead of moving the slider.
 */
// function initCardMediaSwipers(root = document) {
//   const sliders = root.querySelectorAll('.card-media-swiper:not([data-swiper-initialized])');

//   sliders.forEach((el) => {
//     // Skip single-image sliders: nothing to slide, no need for JS overhead.
//     if (el.querySelectorAll('.swiper-slide').length <= 1) return;

//     const swiper = new Swiper(el, {
//       slidesPerView: 1,
//       spaceBetween: 0,
//       loop: false,
//       speed: 300,
//       // Stops a drag/swipe from also registering as a card-link click.
//       preventClicks: true,
//       preventClicksPropagation: true,
//       touchStartPreventDefault: false,
//       pagination: {
//         el: el.querySelector('.swiper-pagination'),
//         clickable: true,
//       },
//       navigation: {
//         nextEl: el.querySelector('.swiper-button-next'),
//         prevEl: el.querySelector('.swiper-button-prev'),
//       },
//     });

//     // Prevent the arrow buttons themselves from bubbling into the card's <a>.
//     ['.swiper-button-next', '.swiper-button-prev'].forEach((selector) => {
//       const btn = el.querySelector(selector);
//       if (btn) {
//         btn.addEventListener('click', (e) => {
//           e.preventDefault();
//           e.stopPropagation();
//         });
//       }
//     });

//     el.setAttribute('data-swiper-initialized', 'true');
//     el._swiperInstance = swiper;

//      // Only bother with hover-swap if there's a second image
//   if (swiper.slides.length > 1) {
//     el.addEventListener('mouseenter', () => {
//       swiper.slideTo(1);
//     });

//     el.addEventListener('mouseleave', () => {
//       swiper.slideTo(0);
//     });
//   }

//   });
// }

// document.addEventListener('DOMContentLoaded', () => initCardMediaSwipers());

// // Re-run after any dynamic re-render (quick-add modals, infinite scroll,
// // section re-renders in the theme editor, filtered/sorted collection grids).
// document.addEventListener('shopify:section:load', () => initCardMediaSwipers());


document.addEventListener('click', function (event) {
  const link = event.target.closest(
    'a[href="#shopify-section-template--23059791184090__linkboxes_viva_RjcgPX"]'
  );

  if (!link) return;

  event.preventDefault();

  const section = document.querySelector(
    '#shopify-section-template--23059791184090__linkboxes_viva_RjcgPX'
  );

  if (section) {
    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
});